import { render, staticRenderFns } from "./FitmentItemPlusComplement.vue?vue&type=template&id=173793b9&scoped=true&"
import script from "./FitmentItemPlusComplement.vue?vue&type=script&lang=js&"
export * from "./FitmentItemPlusComplement.vue?vue&type=script&lang=js&"
import style0 from "./FitmentItemPlusComplement.vue?vue&type=style&index=0&id=173793b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173793b9",
  null
  
)

export default component.exports